import Carousel from "../components/Carousel_Component";
import HeroSection from "../components/Hero_Section";
import Navbar from "../components/Navbar";


const Home = () => {

    return(
        <>
        <Navbar />
        <HeroSection />
        <Carousel />
        </>
    )
}

export default Home;